// extracted by mini-css-extract-plugin
export default {"day":"Day_day__tsbi4","real-day":"Day_real-day__Eql3p","selected":"Day_selected__yV9NE","invalid":"Day_invalid__umUHm"};